import { writable, derived } from "svelte/store";

export const Stores = writable({
  isIndiv: false,
  chiffreAffaire: "0"
});

export const StepTwoStore = writable({});

export const GlobalStore = derived([Stores, StepTwoStore], ([$s1, $s2]) => {
  return {...$s1, ...$s2};
});